// tslint:disable:max-line-length
import React from 'react';

const NotificationIcon: React.SFC<{}> = () => (
    <svg viewBox="0 0 100 100">
        <g>
            <path
                fill="currentColor"
                d="M87.5,83.6c1.8,0,3.3-1.5,3.3-3.3v-4.9c0-0.9-0.4-1.7-1-2.4l-10-10c-0.1-0.1-0.1-0.1-0.1-0.2V42.6 c0-6.5-2.1-12.6-6-17.7c-3.8-5-9.1-8.7-15.1-10.5c-0.1,0-0.2-0.2-0.2-0.3v-1.6c0-2.3-1-4.5-2.7-6.1c-1.5-1.4-3.5-2.2-5.6-2.2 c-2.1,0-4,0.7-5.6,2.2c-1.7,1.5-2.7,3.8-2.7,6.1v1.6c0,0.1-0.1,0.3-0.2,0.3c-6,1.8-11.3,5.5-15.1,10.5c-3.9,5.1-6,11.3-6,17.7v20.3 c0,0.1,0,0.2-0.1,0.2l-10,10c-0.6,0.6-1,1.5-1,2.4v4.9c0,1.8,1.5,3.3,3.3,3.3H87.5z"
            />
            <path
                fill="currentColor"
                d="M9.8,40.2c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5c0-11.8,6.4-22.9,16.6-28.8c0.7-0.4,1-1.3,0.6-2.1 c-0.4-0.7-1.3-1-2.1-0.6C16.8,15.2,9.8,27.2,9.8,40.2"
            />
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="0.528px"
                strokeMiterlimit="10"
                d="M9.8,40.2c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5c0-11.8,6.4-22.9,16.6-28.8c0.7-0.4,1-1.3,0.6-2.1 c-0.4-0.7-1.3-1-2.1-0.6C16.8,15.2,9.8,27.2,9.8,40.2z"
            />
            <path
                fill="currentColor"
                d="M71.2,11.4c10.3,5.9,16.6,17,16.6,28.8c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5c0-12.9-7-25-18.1-31.4 c-0.7-0.4-1.6-0.2-2.1,0.6C70.2,10,70.5,10.9,71.2,11.4"
            />
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="0.528px"
                strokeMiterlimit="10"
                d="M71.2,11.4c10.3,5.9,16.6,17,16.6,28.8c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5c0-12.9-7-25-18.1-31.4 c-0.7-0.4-1.6-0.2-2.1,0.6C70.2,10,70.5,10.9,71.2,11.4z"
            />
            <path
                fill="currentColor"
                d="M37.5,83c0.8,6.4,6.2,11.4,12.9,11.4c6.6,0,12.1-5,12.9-11.4H37.5z"
            />
        </g>
    </svg>
);
export { NotificationIcon };
